// src/utils/constants.js

export const PRESETS = {
  manufacturing: { hasOrders: true, hasRawMaterials: true, hasWalkinSales: true, hasAmbassadors: true, hasProfitAlloc: true, hasAssets: true, salesCanLogPayments: false },
  retail_only: { hasOrders: false, hasRawMaterials: false, hasWalkinSales: true, hasAmbassadors: true, hasProfitAlloc: true, hasAssets: true, salesCanLogPayments: false },
  service_only: { hasOrders: true, hasRawMaterials: false, hasWalkinSales: false, hasAmbassadors: true, hasProfitAlloc: true, hasAssets: true, salesCanLogPayments: false },
  custom: { hasOrders: true, hasRawMaterials: true, hasWalkinSales: true, hasAmbassadors: true, hasProfitAlloc: true, hasAssets: true, salesCanLogPayments: false },
};

export const NAV_GROUPS = [
  {
    key: "sales",
    icon: "🛍️",
    label: "Sales",
    keys: ["orders", "payments", "finishedgoods", "newsale", "pendingsales", "saleslog"],
  },
  {
    key: "operations",
    icon: "⚙️",
    label: "Operations",
    keys: ["inventory", "expenses"],
  },
  {
    key: "finance",
    icon: "💰",
    label: "Finance",
    keys: ["capital", "allocation", "assets"],
  },
  {
    key: "people",
    icon: "🏅",
    label: "People",
    keys: ["ambassadors", "users"],
  },
  {
    key: "reports",
    icon: "📊",
    label: "Reports",
    keys: ["history", "audit", "aianalysis"],
  },
  {
    key: "manage",
    icon: "🛠️",
    label: "Manage",
    keys: ["settings", "admin"],
  },
];

export const FLAG_LABELS = {
  hasOrders: { label: "Custom Orders & Payments", desc: "Order taking, production tracking, payment collection" },
  hasRawMaterials: { label: "Raw Materials Tracker", desc: "If OFF, product costs are deducted directly from cash" },
  hasWalkinSales: { label: "Walk-in Sales / POS", desc: "Display stock management and walk-in customer sales" },
  hasAmbassadors: { label: "Ambassador / Referral System", desc: "Commission tracking, withdrawal requests, leaderboard" },
  hasProfitAlloc: { label: "Profit Allocation Module", desc: "Formal profit distribution — reinvest, distribute, retain" },
  hasAssets: { label: "Asset Register", desc: "Equipment, furniture, vehicles, electronics" },
  salesCanLogPayments: { label: "Sales Staff Can Log Payments", desc: "For businesses without a cashier — lets sales staff view and record order payments (editing stays manager-only)" },
};